export const ENVIRONMENT = {
  DEV: "dev",
  STG: "stg",
  PROD: "prod",
};
